/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import upperArch from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/assets/upper-arch.svg';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { setForm } from '@brands/store/slices/patientFormSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { VscDeviceCamera } from 'react-icons/vsc';

import Container from '../../../../Components/Container/Container';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import AddDependentModal from '../../../MyProfile/Patient/Sections/AddDependentModal/AddDependentModal';
import Camera from './Components/Camera';
import styles from './styles.module.scss';

interface UploadedFile {
  name: string;
  dataURL: string;
}

const ImageUploadStepFive = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const roleNavigate = useRoleNavigate();
  const { values } = useAppSelector(selectPatientForm);
  const screenSize = useWindowSize();
  const [openCamera, setOpenCamera] = useState(false);
  const [showAddDependentModal, setShowAddDependentModal] = useState<boolean>(false);
  const [images, setImages] = useState<UploadedFile | null>(
    (values.find((item) => item.form_question_id === 17)?.value.images as UploadedFile[])?.find(
      (leftSideImage) => leftSideImage.name === 'UpperArchSideImage.png',
    ) || null,
  );

  const onCloseCamera = (): void => {
    setOpenCamera(false);
  };

  const onPhotoTaken = (uri: string): void => {
    setImages({ dataURL: uri, name: 'UpperArchSideImage.png' });
  };

  const deleteMedia = (): void => {
    setImages(null);
  };

  useEffect(() => {
    const payload = [...values];
    const filteredPayload = payload.filter((item) => item.form_question_id !== 17);

    if (images === null) {
      const existingImages =
        (values.find((item) => item.form_question_id === 17)?.value.images as UploadedFile[]) || [];

      const updatedImages = existingImages.filter((img) => img.name !== 'UpperArchSideImage.png');

      filteredPayload.push({
        form_question_id: 17,
        value: {
          images: updatedImages,
        },
      });

      dispatch(setForm(filteredPayload));
    } else {
      const existingImages =
        (values.find((item) => item.form_question_id === 17)?.value.images as UploadedFile[]) || [];

      const updatedImages = existingImages.filter((img) => img.name !== images.name);
      updatedImages.push(images);

      filteredPayload.push({
        form_question_id: 17,
        value: {
          images: updatedImages,
        },
      });

      dispatch(setForm(filteredPayload));
    }
  }, [images]);

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
      }}
      childrenStyle={{ zIndex: '2' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.uploadImageContainerDiv}>
          <PatientIntakeNavigation progress={88} />
          <div className={`${styles.formTitle} d-flex mt-3`}>Guided Image Capture</div>
          <form className={styles.formContainer}>
            <div className={styles.wrapper}>
              <div className={styles.formContent}>
                <div className={styles.uploadFlow}>
                  <span className={styles.formContentFlowImageSpan}>
                    {images !== null ? (
                      <div className={`${styles.formContentFlowImageSpan}`}>
                        <div className={styles.imageWrap} key={images.dataURL}>
                          <span className={styles.removeImage} onClick={() => deleteMedia()}>
                            <IoClose />
                          </span>
                          <img src={images.dataURL} alt={images.name} />
                        </div>
                      </div>
                    ) : (
                      <img src={upperArch} />
                    )}
                  </span>
                  <span className={styles.uploadImageQRContainerText2}>Image 5 of 5</span>
                  <span className={styles.uploadImageQRContainerText1}>Upper Arch</span>
                  {images === null && (
                    <span className={styles.uploadImageQRContainerText3}>
                      Flip your phone upside down to capture a better angle, and widen your mouth as much as possible to
                      ensure a clear photograph of your upper teeth.
                    </span>
                  )}

                  <div className={`${styles.selectImages} ${styles.cameraBtn}`} onClick={() => setOpenCamera(true)}>
                    <VscDeviceCamera />
                    {images === null ? 'Take Photo' : 'Retake Photo'}
                  </div>
                </div>
              </div>
              <div className={styles.btnContainer}>
                <Button
                  type="button"
                  onClick={() => roleNavigate('/upload-image-flow')}
                  onTouchStart={() => {
                    roleNavigate('/upload-image-flow');
                  }}
                  style={{ width: '245px', height: '46px', cursor: 'pointer', touchAction: 'manipulation' }}
                  className={`${images !== null ? styles.nextBtn : styles.skipBtn}`}
                >
                  {images !== null ? 'Next' : 'Skip'}
                </Button>
                <Button variant="text" className={styles.medicalHistoryFooterBack} onClick={() => roleNavigate(-1)}>
                  <ArrowBackIosNewIcon />
                  Back
                </Button>
              </div>
            </div>
          </form>
          {openCamera && <Camera onClose={onCloseCamera} onPhotoTaken={onPhotoTaken} />}
        </div>
      </div>
      {showAddDependentModal && (
        <AddDependentModal isOpen={showAddDependentModal} setIsOpen={setShowAddDependentModal} isFromSelectNeeds />
      )}
    </Container>
  );
};
export default ImageUploadStepFive;
